import React from 'react';
import cn from 'classnames';

import s from './StageIndicator.module.scss';
import { Tooltip } from '@chakra-ui/react';

type StageIndicatorItemProps = {
  className?: string;
  label: string;
  stage: string;
  letterCount?: number;
};

function StageIndicatorItem({
  className,
  label,
  stage,
  letterCount,
}: StageIndicatorItemProps): JSX.Element | null {
  if (!label) return null;
  return (
    <div
      className={cn(s.stageIndicator__item, className, { [s[stage]]: stage })}
    >
      <Tooltip label={label}>
        <div className={s.stageIndicator__label}>
          {label.slice(0, letterCount || 1).toUpperCase()}
        </div>
      </Tooltip>
    </div>
  );
}

export default StageIndicatorItem;
